<template>
  <div class="user-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <div class="page-content">
      <div class="page-header">
        <div class="header-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <circle cx="14" cy="10" r="4.5" stroke="#2dd4bf" stroke-width="1.8" />
            <path d="M4 24C4 19.5817 8.02944 16 14 16C19.9706 16 24 19.5817 24 24" stroke="#2dd4bf" stroke-width="1.8"
              stroke-linecap="round" opacity="0.7" />
            <circle cx="14" cy="14" r="12" stroke="#2dd4bf" stroke-width="1.5" opacity="0.25" />
          </svg>
        </div>
        <h1 class="page-title" v-if="is_login">个人中心</h1>
        <h1 class="page-title" v-else>账户</h1>
        <p class="page-desc" v-if="is_login">{{ self_info_data.user }}</p>
        <p class="page-desc" v-else>请登录后查看账户信息</p>
      </div>

      <div v-if="is_login === true">
        <div class="info-card">
          <div class="info-card-title">
            <div class="title-dot"></div>
            <span>账号信息</span>
          </div>

          <div class="info-list">
            <div class="info-item">
              <span class="info-label">账号</span>
              <span class="info-value">{{ self_info_data.user }}</span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <span class="info-label">注册时间</span>
              <span class="info-value">{{ self_info_data.ct }}</span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <span class="info-label">设备数量</span>
              <span class="info-value">{{ self_info_data.devcont }}</span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item info-item--action" @click="showPrivacy = true">
              <span class="info-label">账号注销</span>
              <span class="info-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item info-item--action" @click="gotoreset">
              <span class="info-label">修改密码</span>
              <span class="info-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div class="bottom-action">
          <button class="submit-btn submit-btn--outline" @click="logout">
            退出登录
          </button>
        </div>
      </div>

      <div v-else class="not-login">
        <div class="not-login-icon">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="20" r="8" stroke="#cbd5e1" stroke-width="2" opacity="0.6" />
            <path d="M10 48C10 38.0589 18.0589 30 28 30C37.9411 30 46 38.0589 46 48" stroke="#cbd5e1" stroke-width="2"
              stroke-linecap="round" opacity="0.4" />
            <circle cx="28" cy="28" r="24" stroke="#cbd5e1" stroke-width="1.5" opacity="0.2" />
          </svg>
        </div>
        <p class="not-login-text">您还未登录</p>
        <div class="bottom-action">
          <button class="submit-btn" @click="goto_login">
            登录账户
          </button>
        </div>
      </div>
    </div>

    <van-tabbar route class="crystal-tabbar">
      <van-tabbar-item icon="home-o" to="/devlist" replace>主页</van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/group" replace>分组管理</van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/user" replace>个人中心</van-tabbar-item>
    </van-tabbar>

    <van-popup v-model="showPrivacy" position="bottom" :style="{ height: '80%' }" closeable round class="crystal-popup">
      <div class="popup-inner">
        <h1 class="popup-title">注销风险提示</h1>
        <div class="popup-warning">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="#fb7185" stroke-width="1.5" opacity="0.4" />
            <path d="M10 6V11" stroke="#fb7185" stroke-width="1.8" stroke-linecap="round" />
            <circle cx="10" cy="14" r="0.8" fill="#fb7185" />
          </svg>
          <span>注销后所有数据将被永久删除，且无法恢复</span>
        </div>

        <div class="popup-list">
          <div class="popup-list-item">
            <span class="item-num">1</span>
            <span>注销后该账户所有数据将被删除（包括但不限于，绑定的设备，设备数据，所有记录）。</span>
          </div>
          <div class="popup-list-item">
            <span class="item-num">2</span>
            <span>注销后立即生效。</span>
          </div>
        </div>

        <div class="popup-agree" @click="agreed = !agreed">
          <div class="agree-checkbox">
            <svg v-if="agreed" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect width="18" height="18" rx="4" fill="#fb7185" />
              <path d="M5 9L7.5 11.5L13 6" stroke="white" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" stroke="#d1d5db" fill="white" />
            </svg>
          </div>
          <span class="agree-text">我已阅读并同意</span>
          <span class="agree-link" @click.stop="showp2 = true">《账号注销协议》</span>
        </div>

        <button class="submit-btn submit-btn--danger" @click="cancellation_user" :disabled="!agreed">
          确认注销
        </button>
      </div>
    </van-popup>

    <van-popup v-model="showp2" position="bottom" :style="{ height: '80%' }" closeable round class="crystal-popup">
      <div class="protocol-content">
        <h1>酷度智能硬件平台账号注销协议</h1>

        <div class="protocol-warning">
          <strong>特别说明：</strong>注销账号后，您将无法再以此账号登录和使用本平台的相关产品与服务，且账号一旦注销完成，将无法恢复。请您在注销前慎重考虑。
        </div>

        <p>
          请您务必先行仔细阅读和充分理解本《酷度智能硬件平台账号注销协议》，在同意全部内容后，您勾选本注销协议并点击下一步注销操作的行为即视为您已经同意签署和遵守本协议全部内容。如您在注销后需要再次使用我们的服务的，欢迎您重新注册。
        </p>

        <h2>一、您需要首先知悉的是：账号注销将会对您产生如下影响：</h2>

        <ol>
          <li>账号一旦注销，您将无法登录、使用该账号，您将无法再以此账号登录/使用/继续使用本平台的相关产品与服务。</li>
          <li>账号一旦注销，您曾通过该账号登录、使用的产品与服务下的所有内容、信息、数据、记录将会被删除，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外），包括：
            <ul>
              <li>该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号等）；</li>
              <li>该账号下的您的个人信息（同时您亦不再享有《酷度物联网平台隐私政策》中约定的您的用户权利，但法律法规另有规定的除外）；</li>
              <li>该账号曾添加的所有内容；</li>
              <li>其他所有内容、信息、数据、记录。</li>
            </ul>
          </li>
          <li>您申请账号注销的行为即表明您同意放弃该账号的产品与服务使用期间已产生的但未消耗完毕的权益。即账号一旦注销，我们将会对该账号下的全部权益做清除处理，包括：
            <ul>
              <li>您的电话通知尚未使用的剩余条数；</li>
              <li>您的短信通知尚未使用的剩余条数；</li>
            </ul>
          </li>
          <li>账号一旦注销完成，将无法恢复（即使您在注销后以同一手机号码再次向我们申请注册本平台账号，此时该账号为新的用户账号）。</li>
          <li>账号一旦注销，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）。</li>
          <li>其他因账号注销产生的结果。</li>
        </ol>

        <h2>二、在您向我们申请注销账号之前或正在申请注销账号的过程中，为保障您的账号安全和财产权益，请您先行检查与确保您申请注销的账号已经同时满足以下几点，包括：</h2>

        <ol>
          <li>该账号是通过我们的官方渠道注册，且为您本人注册的账号；</li>
          <li>其他为了保障您的账号安全和财产权益需要满足的内容；</li>
        </ol>

        <p>上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系客服协助处理。</p>

        <div class="protocol-contact">
          <span>客服热线：0554-6673738</span>
        </div>

        <div class="protocol-legal">
          <p>本协议适用中华人民共和国法律。因本协议引发的争议，双方应友好协商解决；协商不成的，任何一方均可向本平台运营方住所地有管辖权的人民法院提起诉讼。</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'UserPage',
    data() {
      return {
        self_info_data: {},
        showPrivacy: false,
        showp2: false,
        agreed: false,
        is_login: true,
      };
    },
    mounted() {
      this.self_info();
    },
    methods: {
      gotoreset() {
        this.$router.push({
          name: 'passwordreset'
        })
      },
      gotocancellation() {
        this.$router.push({
          name: 'cancellation'
        })
      },
      cancellation_user() {
        if (this.agreed == false) {
          this.$dialog.alert({
            title: '注销协议',
            message: '为了更好的保护您的权益，同时遵守相关监管要求，请认真阅读《酷度智能硬件平台账号注销协议》',
          });
          return;
        }
        const qs = require('qs');
        this.$axios.post('/api/user/cancellation', qs.stringify({
            'user': ''
          }))
          .then((response) => {
            if (response.data.error_code === 0) {
              this.$router.push({
                path: '/login',
                name: 'login'
              })
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      self_info(did, gid) {
        const qs = require("qs");
        this.$axios
          .post(
            "/api/user/self_info",
            qs.stringify({
              a: 11
            })
          )
          .then((response) => {
            if (response.data.error_code === 0) {
              this.self_info_data = response.data;
              this.is_login = true
              console.log(this.is_login);
            } else if (response.data.error_code === 301) {
              this.is_login = false
              /*
                this.$router.push({
                path: "/login",
                name: "login"
              });
              */
            }
          })
          .catch((error) => {});
      },
      logout() {
        this.$dialog.confirm({
          title: '退出登录',
          message: '确认退出登录？'
        }).then(() => {
          this.$axios.post('/api/user/logout')
            .then((response) => {
              if (response.data.error_code === 0) {
                this.$router.push({
                  path: '/login',
                  name: 'login'
                })
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
      },
      goto_login() {
        this.$router.push({
          path: '/login',
          name: 'login'
        })
      }
    }
  }
</script>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

  .van-tabbar.crystal-tabbar {
    border-top: 1px solid #f1f5f9;
    background: #ffffff;
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.04);
  }

  .crystal-tabbar .van-tabbar-item--active {
    color: #2dd4bf !important;
  }

  .crystal-tabbar .van-tabbar-item__icon {
    font-size: 22px;
  }

  .crystal-tabbar .van-tabbar-item__text {
    font-size: 11px;
    font-weight: 500;
  }

  .crystal-popup {
    font-family: "Inter", "Noto Sans SC", sans-serif;
  }
</style>

<style scoped>
  .user-page {
    min-height: 100vh;
    min-height: 100dvh;
    background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
    font-family: "Inter", "Noto Sans SC", sans-serif;
    position: relative;
    overflow: hidden;
  }

  .bg-shapes {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
  }

  .shape {
    position: absolute;
    border-radius: 50%;
  }

  .shape-1 {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(45, 212, 191, 0.1) 0%, transparent 70%);
    top: -80px;
    right: -50px;
    animation: shapeDrift 20s ease-in-out infinite alternate;
  }

  .shape-2 {
    width: 240px;
    height: 240px;
    background: radial-gradient(circle, rgba(251, 113, 133, 0.06) 0%, transparent 70%);
    bottom: 120px;
    left: -60px;
    animation: shapeDrift 18s ease-in-out infinite alternate-reverse;
  }

  .shape-3 {
    width: 160px;
    height: 160px;
    background: radial-gradient(circle, rgba(167, 139, 250, 0.05) 0%, transparent 70%);
    top: 50%;
    left: -30px;
    animation: shapeDrift 22s ease-in-out infinite alternate;
  }

  .shape-4 {
    width: 180px;
    height: 180px;
    background: radial-gradient(circle, rgba(251, 191, 36, 0.04) 0%, transparent 70%);
    bottom: 40%;
    right: -40px;
    animation: shapeDrift 16s ease-in-out infinite alternate-reverse;
  }

  @keyframes shapeDrift {
    0% {
      transform: translate(0, 0) scale(1);
    }

    100% {
      transform: translate(30px, -20px) scale(1.1);
    }
  }

  .page-content {
    position: relative;
    z-index: 1;
    padding-bottom: 110px;
    min-height: 100vh;
    min-height: 100dvh;
    animation: pageEnter 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  @keyframes pageEnter {
    from {
      opacity: 0;
      transform: translateY(12px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .page-header {
    text-align: center;
    padding: 36px 20px 24px;
  }

  .header-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }

  .page-title {
    font-weight: 700;
    font-size: 22px;
    color: #1e293b;
    margin: 0 0 4px;
    letter-spacing: 0.5px;
  }

  .page-desc {
    font-size: 13px;
    color: #94a3b8;
    margin: 0;
    font-weight: 400;
    word-break: break-all;
  }

  .info-card {
    background: #ffffff;
    border-radius: 18px;
    margin: 0 16px;
    padding: 18px 0 4px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
    animation: cardSlide 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  @keyframes cardSlide {
    from {
      opacity: 0;
      transform: translateY(12px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .info-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 18px 14px;
  }

  .title-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #2dd4bf;
    flex-shrink: 0;
  }

  .info-card-title span {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
  }

  .info-list {
    padding: 0;
  }

  .info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    min-height: 20px;
  }

  .info-item--action {
    cursor: pointer;
    transition: background 0.15s;
  }

  .info-item--action:active {
    background: #f8fafc;
  }

  .info-label {
    font-size: 14px;
    color: #475569;
    font-weight: 500;
  }

  .info-value {
    font-size: 14px;
    color: #94a3b8;
    font-weight: 400;
    text-align: right;
  }

  .info-arrow {
    display: flex;
    align-items: center;
  }

  .info-divider {
    height: 1px;
    background: #f1f5f9;
    margin: 0 18px;
  }

  .bottom-action {
    padding: 24px 16px 0;
  }

  .submit-btn {
    display: block;
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 3px;
    cursor: pointer;
    color: #fff;
    background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);
    box-shadow: 0 4px 16px rgba(45, 212, 191, 0.3);
    transition: transform 0.2s, box-shadow 0.2s;
    font-family: inherit;
  }

  .submit-btn:active {
    transform: scale(0.97);
    box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
  }

  .submit-btn--outline {
    background: transparent;
    color: #2dd4bf;
    border: 2px solid #2dd4bf;
    box-shadow: none;
  }

  .submit-btn--outline:active {
    background: rgba(45, 212, 191, 0.04);
    box-shadow: none;
  }

  .submit-btn--danger {
    background: linear-gradient(135deg, #fb7185 0%, #f43f5e 100%);
    box-shadow: 0 4px 16px rgba(251, 113, 133, 0.3);
  }

  .submit-btn--danger:active {
    box-shadow: 0 2px 8px rgba(251, 113, 133, 0.25);
  }

  .submit-btn--danger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .not-login {
    text-align: center;
    padding-top: 40px;
  }

  .not-login-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  .not-login-text {
    font-size: 15px;
    color: #94a3b8;
    margin: 0 0 8px;
  }

  .popup-inner {
    padding: 28px 24px 36px;
    min-height: 100%;
    background: #fff;
  }

  .popup-title {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    text-align: center;
    margin: 0 0 16px;
  }

  .popup-warning {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff1f2;
    border-radius: 12px;
    padding: 12px 14px;
    margin-bottom: 20px;
    font-size: 13px;
    color: #e11d48;
    font-weight: 500;
  }

  .popup-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
  }

  .popup-list-item {
    display: flex;
    gap: 10px;
    font-size: 14px;
    color: #475569;
    line-height: 1.6;
  }

  .item-num {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    font-family: "Inter", sans-serif;
  }

  .popup-agree {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 2px 0;
  }

  .agree-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .agree-text {
    font-size: 13px;
    color: #94a3b8;
  }

  .agree-link {
    font-size: 13px;
    color: #fb7185;
    font-weight: 500;
    cursor: pointer;
  }

  .protocol-content {
    padding: 28px 20px 40px;
    font-family: "Noto Sans SC", sans-serif;
    color: #475569;
    font-size: 14px;
    line-height: 1.8;
    background: #fff;
    min-height: 100%;
  }

  .protocol-content h1 {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    text-align: center;
    margin: 0 0 16px;
  }

  .protocol-content h2 {
    font-size: 16px;
    font-weight: 600;
    color: #fb7185;
    margin: 24px 0 12px;
  }

  .protocol-content p {
    margin: 0 0 12px;
  }

  .protocol-content ul,
  .protocol-content ol {
    padding-left: 20px;
    margin: 8px 0 12px;
  }

  .protocol-content li {
    margin-bottom: 8px;
  }

  .protocol-warning {
    background: #fff1f2;
    border-left: 3px solid #fb7185;
    padding: 12px 14px;
    border-radius: 0 8px 8px 0;
    margin: 12px 0;
    font-size: 13px;
    color: #e11d48;
  }

  .protocol-contact {
    background: #fff1f2;
    border: 1px solid #fecdd3;
    border-radius: 10px;
    padding: 14px 18px;
    text-align: center;
    margin: 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: #e11d48;
  }

  .protocol-legal {
    margin-top: 20px;
    font-size: 13px;
    color: #94a3b8;
  }
</style>